export const mgl: Record<string, any> = {};

(window as any).mgl = mgl;
